import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IUserProfileState, IUserProfileData } from './types';

const initState: IUserProfileState = {
  data: null,
  isLoading: false,
};

function onUserProfileRequest(state: IUserProfileState) {
  return { ...state, isLoading: true };
}

function onUserProfileSuccess(state: IUserProfileState, { payload }: { payload: IUserProfileData }) {
  return { ...state, data: payload, isLoading: false };
}

function onUserProfileError(state: IUserProfileState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.USER_PROFILE_REQUEST]: onUserProfileRequest,
  [actions.USER_PROFILE_SUCCESS]: onUserProfileSuccess,
  [actions.USER_PROFILE_ERROR]: onUserProfileError,
});
